import React from 'react';
import TimeAgo from 'react-timeago';

import {PaginationScroll} from 'Components/Partials';
import {isSameChat, isSameChatCheck, isThisUser} from 'Components/Networking/Sub';

import ChatsApi from 'Services/Api/Networking/Chats';

import {User, Socket} from 'Services';
import {translation} from 'Services/TranslationHelpers';
import {mergeObjectsIntoPaginationData} from 'Services/BaseHelpers';

export default class Chat extends React.Component {
    /**
     * @var state
     * @type {{messages: null|object}}
     * @type {{new_message: string}}
     */
    state = {
        messages: null,
        new_message: '',
        scrollToStart: false,
    }

    /**
     * @method constructor
     */
    constructor() {
        super();
        this.newMessageRef = React.createRef();
    }

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        this.subscribeToBroadcasts();
    };

    /**
     * @method componentDidUpdate
     */
    componentDidUpdate() {
        // Commented out by default as most clients don't want this.
        // this.focusOnNewMessageInput();
    }

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount() {
        this.unsubscribeFromBroadcasts();
    }

    /**
     * @method subscribeToBroadcasts
     */
    subscribeToBroadcasts = () => {
        // Listen for new messages.
        Socket.getConnection().private('networking.' + User.id)
            .listen('NetworkingMessagePosted', (e) => {
                this.handleNewMessage(e.message);
            });
    }

    /**
     * @method unsubscribeFromBroadcasts
     */
    unsubscribeFromBroadcasts = () => {
        // Stop listening for new messages.
        Socket.getConnection().leave('networking.' + User.id);
    }

    /**
     * @method handleNewMessage
     * @param {object} message
     */
    handleNewMessage = (message) => {
        const {selected_chat} = this.props;
        const {messages} = this.state;

        if (selected_chat) {
            if ((selected_chat.type === "App\\Models\\NetworkingGroup" && isSameChat(selected_chat, message.message_to))
                || (selected_chat.type === "App\\Models\\SupportTicket" && isSameChat(selected_chat, message.message_to))
                || (isSameChat(selected_chat, message.user_from) && isThisUser(message.message_to))
                || (isThisUser(message.user_from) && isSameChat(selected_chat, message.message_to)))
            {
                this.setState({
                    messages: mergeObjectsIntoPaginationData(messages, [message]),
                    scrollToStart: true
                });
            }
        }
    }

    /**
     * @method focusOnNewMessageInput
     */
    focusOnNewMessageInput = () => {
        if (this.newMessageRef.current !== null) {
            this.newMessageRef.current.focus();
        }
    }

    /**
     * @method sendMessage
     */
    sendMessage = async () => {
        const {selected_chat} = this.props;
        const {new_message} = this.state;

        if (new_message !== null && new_message !== '') {
            // Set new_message to empty straight away so the message can't be sent twice by accident
            this.setState({
                new_message: '',
            });

            const response = await ChatsApi.postMessage(selected_chat.type, selected_chat.id, new_message);

            this.handleNewMessage(response.data.data);
        }
    }

    /**
     * @method handleNewMessageKeyDown
     * @param {event} e
     */
    handleNewMessageKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.sendMessage();
        }
    }

    /**
     * @method sortMessages
     * @param {object} message_a
     * @param {object} message_b
     * @return {integer}
     */
    sortMessages = (message_a, message_b) => {
        // Order by message created_at date.
        var x = new Date(message_a.created_at.iso_string);
        var y = new Date(message_b.created_at.iso_string);

        return y - x;
    }

    /**
     * @method renderMessages
     * @return {*}
     */
    renderMessages() {
        const {messages, scrollToStart} = this.state;
        const {selected_chat} = this.props;

        return (
            <PaginationScroll
                scrollDown={false}
                apiCall={(page) => ChatsApi.getChat(selected_chat.type, selected_chat.id, page)}
                updateData={(data) => this.setState({messages: data})}
                data={messages}
                containerClassName="p-4"
                scrollToStart={scrollToStart}
                scrollToStartCallback={(v) => this.setState({scrollToStart: v})}
                key={selected_chat.type + '_' + selected_chat.id}
            >
                {messages && messages.data.length === 0 &&
                    <div className="text-center mt-4">
                        <p className="font-bold text-app-blue">
                            {translation('networking_frontend', 'selected_chat') + ' ' +
                            (selected_chat.type === "App\\Models\\SupportTicket" ?
                                'Support' :
                                selected_chat.name)}
                        </p>

                    </div>
                }

                {messages && messages.data.sort((a, b) => {
                    return this.sortMessages(a, b)
                })
                    .map((message, i) => (this.renderMessage(message)))
                    .reverse()}
            </PaginationScroll>
        );
    }

    /**
     * @method renderSystemMessage
     * @param {object} message
     * @return {*}
     */
    renderSystemMessage(message) {
        return (
            <div
                className="text-center p-2 m-1 w-full text-app-blue text-sm font-bold"
                key={message.id}
            >
                {message.message + ' - '}
                <TimeAgo date={message.created_at.iso_string}/>
            </div>
        );
    }
}
